module.exports = __webpack_public_path__ + "img/commercial-paper.c021a404.svg";